<!--
 * @Author: your name
 * @Date: 2022-02-25 14:43:23
 * @LastEditTime: 2022-10-22 14:56:27
 * @LastEditors: pyx 3245266940@qq.com
 * @Description: 电子合同 分类列表页面
 * @FilePath: \wx-front\src\views\contract\contractList.vue
-->
<template>
  <div class="wrap flexCol">
    <div>
      <div class="tabsBox">
        <van-tabs
          @click="clickTabs"
          color="#1A7AF8"
          title-active-color="#323233"
          title-inactive-color="#9EA5BB"
        >
          <van-tab name="1" title="待我签署"></van-tab>
          <van-tab name="2" title="已生效"></van-tab>
          <van-tab name="3" title="已拒签"></van-tab>
        </van-tabs>
      </div>
      <div class="listBox">
        <div class="listContent">
          <div style="margin-bottom: 0.24rem;border: 1px solid #EBEDF0"></div>
          <div class="emptyBox colAc" v-if="list.length == 0">
            <img src="../../assets/static/emptyList.png" alt="" />
            <div class="fontH3 fontScN8">暂时还没有记录哦</div>
          </div>
          
            <div class="itemBox" v-for="(item, index) in list" :key="index" @click="goDetail(item.id)">
                <div class="boxTop rowJb rowAs">
                  <div class="title  fontH2 fontScN8">{{ item.title }}</div>
                  <div class="status fontH4 rowJcAc" :class="status[item.status].color">
                    {{ status[item.status].text }}
                  </div>
                </div>
                <div class="formLine fontH2 fontScN7 textOver">
                  {{ campus.split('-')[0] }}
                </div>
                <div class="titleLine fontH3 fontScN6">
                  课程名称
                </div>
                <div class="textLine fontH2 fontScN7 textOver">
                  {{ item.courseName }}
                </div>
                <div class="titleLine fontH3 fontScN6">
                  学员签署截止日期
                </div>
                <div class="textLine fontH2 fontScN7 textOver">
                  {{ item.signatureDeadlineTime }}
                </div>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { getContractListAPI } from "../../utils/api/contractAPI";

export default {
  data() {
    return {
      list: [//列表
        // {
        //   name:'合同名称合同名称合同名称合同名称合同名称',
        //   status:1,
        //   organization:'转角马艺术培训机构转角马艺术培训机构转角马艺术培训机构',
        //   endTime:'2022-02-24 10:00:00',
        // }, 
      ], 
      status: { //状态map
        1: { color: "waitFor", text: "待我签署" },
        2: { color: "effective", text: "已生效" },
        3: { color: "rejectSign", text: "已拒签" },
      },
      campusCode: "",//校区code
      parentUid: "",//用户id
      campus: "",//校区名
      statusList: 1,//tabs
    };
  },
  created() {
    var selectedCampus = {};
    if (this.$common.getCache("campusItem")) {
      // 判断本地有无校区信息
      var selectedCampus = JSON.parse(this.$common.getCache("campusItem"));
    } else {
      var campusList = JSON.parse(this.$common.getCache("customerAuthList"));
      if (campusList) {
        var selectedCampus = campusList[0];
      }
    }
    this.campus = selectedCampus.campusName;
    this.campusCode = selectedCampus.campusCode;
    this.parentUid = selectedCampus.customerId;
  },
  mounted() {
     this.getList();
  },
  methods: {
    //进入合同详情
    goDetail(id){
      this.$router.push({
        name: "ContractDetail",
        params: { id: id },
      });
    },
    //切换tabs
    clickTabs(name, title) {
      console.log("点击切换", name, title);
      this.statusList = name;
      this.getList();
    },
    //获取合同列表
    getList() {
      var obj = {
        customerId: this.parentUid,
        campusCode: this.campusCode,
        status: this.statusList,
      };
      getContractListAPI(obj)
        .then((res) => {
          if (res.resultCode == 200) {
            console.log("获取合同列表", res.data);
            this.list = res.data?res.data:[]
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  background: #FFFFFF;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}
.listBox {
  height: calc(100% - 0.5rem);
  //margin-bottom: 0.44rem;
  margin-top: 0.5rem;
  box-sizing: border-box;
  .listContent {
    border-top: 1px solid #EBEDF0;
    height: 100%;
    overflow: auto;
    flex: 1;
    margin: 0 0.16rem;
    box-sizing: border-box;
  }
}
.emptyBox {
  img {
    width: 165px;
    height: 114px;
    margin-top: 40px;
  }
}
.van-list {
  margin-top: 0.04rem;
  padding: 0 0.16rem 0.16rem 0.16rem;
}
.itemBox {
  margin-bottom: 16px;
  padding: 0.16rem 0.2rem 0.08rem 0.2rem;
  border: 1px solid #E8EBF3;
  border-radius:0.12rem;
  box-sizing: border-box;
  width: 100%;
  .boxTop {
    margin-bottom: 6px;
    .title {
      font-weight: 500;
      // max-width: 2.3rem;
    }
    .status {
      width: 0.6rem;
      min-width: 0.6rem;
      height: 24px;
    //   padding: 4px 8px;
      border-radius: 4px;
      box-sizing: border-box;
    //   font-size: 0.12rem;
    }
  }
  .formLine {
    word-break: break-all;
    flex-wrap: wrap;
    margin-bottom: 16px;
    max-width: 2.9rem;
  }
}
.waitFor {
  color: #FAAD14;
  background: #FFFBE6;
}
.rejectSign {
  color: #FA3F3F;
  background: #FFF2F0;
}
.effective {
  color: #03BF6D;
  background: #E6FFF0;
}
/deep/.van-button {
  font-size: 0.16rem;
}
/deep/.van-dialog__message {
  font-size: 0.16rem;
}
/deep/.van-tabs__line{
    width: 0.64rem;
}
/deep/.van-tabs--line .van-tabs__wrap{
    height: 52px;
}
/deep/.van-tab{
    font-size: 0.16rem;
}
.tabsBox {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 0.5rem;
}
.titleLine{
  max-width: 2.9rem;
  margin-bottom: 4px;
}
.textLine{
  max-width: 2.9rem;
  margin-bottom: 12px;
}
</style>
